'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback } from 'react';
import { getCoreProps } from '../core/core.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { TextInput } from '../text-input/text-input.component.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const SearchInput = renderWithRef('SearchInput', null, (s, u)=>{
    let b = useRef(void 0), m = assignRefs(u, b), { skin: f = 'standard', disabled: d, onClear: h, onSearchSubmit: _, accessibleTextForClearButton: y, accessibleTextForSearchButton: j } = s, w = _object_without_properties(s, [
        "skin",
        "disabled",
        "onClear",
        "onSearchSubmit",
        "accessibleTextForClearButton",
        "accessibleTextForSearchButton"
    ]), O = getCoreProps(w), S = useCallback((e)=>{
        b.current && (b.current.value = '', b.current.focus()), h && h(e);
    }, [
        h
    ]), v = new Set([
        'swan-search-input'
    ]);
    return 'error' === f && v.add('swan-search-input-skin-error'), jsxs(RenderComp, {
        root: "div",
        classNames: v,
        props: _object_spread({}, O),
        children: [
            jsx(RenderComp, {
                forwardedRef: m,
                root: TextInput,
                props: _object_spread({
                    type: 'search',
                    disabled: d
                }, w)
            }),
            jsx(Button, {
                className: "swan-search-input-clear",
                skin: "tertiary",
                buttonShape: "round",
                onClick: S,
                "aria-label": y,
                disabled: d,
                children: jsx(Icon, {
                    iconType: "clear"
                })
            }),
            jsx("span", {
                className: "swan-search-divider"
            }),
            jsx(Button, {
                type: "submit",
                skin: "tertiary",
                buttonShape: "round",
                className: "swan-search-input-submit",
                onClick: null != _ ? _ : void 0,
                "aria-label": j,
                disabled: d,
                children: jsx(Icon, {
                    iconType: "search"
                })
            })
        ]
    });
});

export { SearchInput };
